import React from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { GetJson } from '@awp/helpers/fetchReact';
import { REST_API, EventTypes } from '@awp/constants';

const HazardForecastDuplicateButton = ({ event, onDuplicate }) => {
  if (!event || event.EventTypeNm !== EventTypes.HazardForecast) return null;

  const canDuplicate = ['Created', 'Edited', 'Transmitted', 'Duplicated'].includes(event.Status);
  if (!canDuplicate) return null;

  const url = REST_API.HAZARD_FORECAST + event.EventId + '/clone';
  const handleDuplicate = async () => {
    GetJson(url)
      .then(async (response) => {
        if (response.ok) {
          toast.success('Hazard Forecast has been cloned');
          const clonedEventId = await response.json();
          onDuplicate(clonedEventId);
        } else {
          toast.error('Failed to clone a Hazard Forecast');
        }
      })
      .finally(() => {});
  };

  return (
    <>
      <i className="fas fa-copy mx-1 my-1 awp-img-btn" title="Duplicate" onClick={() => handleDuplicate()}></i>
    </>
  );
};

HazardForecastDuplicateButton.propTypes = {
  event: PropTypes.any,
  onDuplicate: PropTypes.func,
};

export default HazardForecastDuplicateButton;
